<template>
    <div v-route-title="'ETL任务'">
        <div class="database-view">
            <div class="header-view pr">
                <span class="huishouzhan_title">ETL任务</span>
                <div class="btn-layer">
                    <el-button @click="addRow" type="primary" icon="el-icon-circle-plus-outline">添加任务</el-button>
                </div>
            </div>
            <el-form class="yq-search-form" inline :model="searchModel">
                <el-form-item>
                    <el-input v-model="searchModel.nameLike" style="width: 250px;" placeholder="任务名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="searchModel.types" placeholder="任务类型" clearable style="width: 250px;">
                        <el-option v-for="item in jobTypes" :key="item" :value="item" :label="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="searchModel.lastRunResult" placeholder="最近运行结果" clearable style="width: 140px;">
                        <el-option v-for="item in runResults" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="searchModel.triggerStates" placeholder="触发器状态" clearable style="width: 120px;">
                        <el-option v-for="item in triggerStates" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                   <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
            <div v-if="data">
                <el-table class="yq-table" :data="data.content" style="width: 100%">
                    <el-table-column
                            label="序号"
                            type="index"
                            :index="indexMethod" width="60">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="任务名称">
                    </el-table-column>
                    <el-table-column
                            prop="type"
                            label="任务类型"
                            width="140">
                    </el-table-column>
                    <el-table-column
                            prop="disabled"
                            label="停用" width="60">
                        <boolean-value slot-scope="scope" :value="scope.row.disabled"></boolean-value>
                    </el-table-column>
                    <el-table-column
                            label="定时">
                        <span slot-scope="scope">{{getJobScheduleDescription(scope.row)}}</span>
                    </el-table-column>
                    <el-table-column
                            prop="logLevel"
                            label="日志级别"
                            width="80">
                        <span slot-scope="scope">{{getLogLevelDescription(scope.row.logLevel)}}</span>
                    </el-table-column>
                    <el-table-column
                            prop="lastRunTime"
                            label="最近运行时间"
                            width="170">
                        <pretty-date-time slot-scope="scope" :value="scope.row.lastRunTime"></pretty-date-time>
                    </el-table-column>
                    <el-table-column
                            prop="lastRunResult"
                            label="最近运行结果"
                            width="120">
                        <span slot-scope="scope">{{getJobResultDescription(scope.row.lastRunResult, scope.row.lastRunCost)}}</span>
                    </el-table-column>
                    <el-table-column
                            prop="triggerState"
                            label="触发器状态"
                            width="90">
                        <span slot-scope="scope">{{getTriggerStateDescription(scope.row.triggerState)}}</span>
                    </el-table-column>
                    <el-table-column
                            prop="carteJobStatus"
                            label="任务状态"
                            width="90">
                    </el-table-column>
                    <el-table-column
                            prop="nextFireTime"
                            label="下一次触发时间"
                            width="170">
                        <pretty-date-time slot-scope="scope" :value="scope.row.nextFireTime"></pretty-date-time>
                    </el-table-column>
                    <el-table-column
                            label="操作" width="180">
                        <template slot-scope="scope">
                            <el-link icon="el-icon-view" @click="viewRow(scope.row)">查看</el-link>
                            <el-link icon="el-icon-view" @click="showLogs(scope.row.id)">日志</el-link>
                            <el-link icon="el-icon-edit" @click="editRow(scope.row)">修改</el-link>
                            <el-link icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-link>
                            <el-link icon="el-icon-open" @click="enableRow(scope.row)" v-if="scope.row.disabled">启用</el-link>
                            <el-link icon="el-icon-turn-off" @click="disableRow(scope.row)" v-if="!scope.row.disabled">停用</el-link>
                            <el-link icon="el-icon-turn-off" @click="stopRow(scope.row)" v-if="scope.row.carteJobStatus==='运行中'">停止</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="clear"></div>
        <div class="magin10"></div>
        <div class="foot" v-if="data">
            <el-pagination
                    layout="prev, pager, next" background
                    :total="data.totalElements" :current-page="data.number+1"
                    @current-change="fetchData($event)">
            </el-pagination>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改任务':'添加任务'" :visible.sync="dialogFormVisible" width="1000px">
            <el-form class="yq-etl-job-form" ref="form" :model="model" label-width="110px" :rules="rules" size="mini" inline>
                <el-form-item label="任务名称" prop="name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="任务类型" prop="type" v-if="!model.id">
                    <el-select v-model="model.type" @change="onTypeChange">
                        <el-option v-for="item in jobTypes" :key="item" :value="item" :label="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="定时方式" prop="scheduleType">
                    <el-select v-model="model.scheduleType">
                        <el-option v-for="item in scheduleTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="运行时间" prop="runTime" v-if="model.scheduleType==='ONCE'">
                    <date-picker v-model="model.runTime" type="datetime"></date-picker>
                </el-form-item>
                <el-form-item label="间隔时间" prop="interval" v-if="model.scheduleType==='INTERVAL'">
                    <duration-picker v-model="model.interval"></duration-picker>
                </el-form-item>
                <el-form-item label="CRON表达式" prop="cron" v-if="model.scheduleType==='CRON'">
                    <el-input v-model="model.cron" placeholder="格式：秒 分 时 日 月 星期"></el-input>
                </el-form-item>
                <el-form-item label="日志级别" prop="logLevel">
                    <el-select v-model="model.logLevel">
                        <el-option v-for="item in logLevels" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否停用" prop="disabled">
                    <el-select v-model="model.disabled">
                        <el-option :value="false" label="否"></el-option>
                        <el-option :value="true" label="是"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="参数配置" prop="jobConfig" v-if="model.jobConfig">
                    <el-table :data="model.jobConfig.parameters" max-height="250">
                        <el-table-column
                                prop="name"
                                label="参数名">
                        </el-table-column>
                        <el-table-column
                                prop="defaultValue"
                                label="默认值">
                        </el-table-column>
                        <el-table-column
                                prop="description"
                                label="说明">
                        </el-table-column>
                        <el-table-column
                                prop="value"
                                label="当前值">
                            <el-input slot-scope="scope" v-model="scope.row.value"></el-input>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog v-if="detailsDlg.model" title="任务详情" :visible.sync="detailsDlg.visible" width="1000px">
            <el-divider>任务配置</el-divider>
            <el-form class="yq-etl-job-form" label-width="110px" size="mini" disabled inline>
                <el-form-item label="任务名称">
                    <el-input v-model="detailsDlg.model.name"></el-input>
                </el-form-item>
                <el-form-item label="任务类型">
                    <el-select v-model="detailsDlg.model.type">
                        <el-option v-for="item in jobTypes" :key="item" :value="item" :label="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="定时方式">
                    <el-select v-model="detailsDlg.model.scheduleType">
                        <el-option v-for="item in scheduleTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="运行时间" v-if="detailsDlg.model.scheduleType==='ONCE'">
                    <date-picker v-model="detailsDlg.model.runTime"></date-picker>
                </el-form-item>
                <el-form-item label="间隔时间" v-if="detailsDlg.model.scheduleType==='INTERVAL'">
                    <duration-picker v-model="detailsDlg.model.interval"></duration-picker>
                </el-form-item>
                <el-form-item label="CRON表达式" v-if="detailsDlg.model.scheduleType==='CRON'">
                    <el-input v-model="detailsDlg.model.cron"></el-input>
                </el-form-item>
                <el-form-item label="日志级别">
                    <el-select v-model="detailsDlg.model.logLevel">
                        <el-option v-for="item in logLevels" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否停用">
                    <el-select v-model="detailsDlg.model.disabled">
                        <el-option :value="false" label="否"></el-option>
                        <el-option :value="true" label="是"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="参数配置">
                    <el-table :data="detailsDlg.model.jobConfig.parameters" max-height="250" >
                        <el-table-column
                                prop="name"
                                label="参数名"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="defaultValue"
                                label="默认值"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="description"
                                label="说明"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="value"
                                label="当前值"
                                width="180">
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-form>
            <el-divider>运行情况</el-divider>
            <el-form class="yq-etl-job-form" label-width="110px" size="mini" inline>
                <el-form-item label="最近运行时间">
                    <div><pretty-date-time :value="detailsDlg.model.lastRunTime"></pretty-date-time></div>
                </el-form-item>
                <el-form-item label="最近运行结果">
                    <div>
                        {{getJobResultDescription(detailsDlg.model.lastRunResult, detailsDlg.model.lastRunCost)}}
                    </div>
                </el-form-item>
                <el-form-item label="最近任务日志">
                    <div>
                        <el-button @click="showLogs(detailsDlg.model.id)">查看日志</el-button>
                    </div>
                </el-form-item>
                <el-form-item label="触发器状态">
                    <div>
                        {{getTriggerStateDescription(detailsDlg.model.triggerState)}}
                    </div>
                </el-form-item>
                <el-form-item label="任务状态">
                    <div>
                        {{detailsDlg.model.carteJobStatus}}
                    </div>
                </el-form-item>
                <el-form-item label="下一次触发时间">
                    <div><pretty-date-time :value="detailsDlg.model.nextFireTime"></pretty-date-time></div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="detailsDlg.visible = false">关 闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="任务日志" :visible.sync="logDialog.visible" width="1000px" @close="onLogDialogClose">
            <el-table
                    :data="logDialog.data"
                    style="width: 100%" max-height="400" :show-header="false">
                <el-table-column
                        prop="log"
                        label="日志">
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="logDialog.visible = false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import etlJobService from '../service/etl-job'
    import DurationPicker from '../components/common/DurationPicker'
    import moment from 'moment'
    import dateUtils from '../service/date-utils'

    export default {
        name: "EtlJobAdmin",
        components: {DurationPicker},
        data() {
            const checkCron = (rule, value, callback) => {
                if (value) {
                    etlJobService.checkCronExpression(value).then(response => {
                        if (response.data && !response.data.data) {
                            callback(new Error('CRON表达式格式错误'));
                        } else {
                            callback();
                        }
                    }).catch(() => {
                        callback(new Error('校验出错'));
                    })
                } else {
                    callback();
                }
            }
            return {
                jobTypes: [],
                scheduleTypes: [
                    {value: 'NONE', label: '无'},
                    {value: 'ONCE', label: '运行一次'},
                    {value: 'INTERVAL', label: '间隔运行'},
                    {value: 'CRON', label: 'CRON定时'}
                ],
                triggerStates: [
                    {value: 'WAITING', label: '等待执行'},
                    {value: 'COMPLETE', label: '已完成'},
                    {value: 'ACQUIRED', label: '锁定中'},
                    {value: 'BLOCKED', label: '执行中'},
                    {value: 'PAUSED_BLOCKED', label: '正在暂停'},
                    {value: 'PAUSED', label: '暂停中'},
                    {value: 'ERROR', label: '任务出错'},
                ],
                logLevels: [
                    {value: 'Nothing', label: '不记录'},
                    {value: 'Error', label: '错误'},
                    {value: 'Minimal', label: '最少'},
                    {value: 'Basic', label: '基本'},
                    {value: 'Detailed', label: '详细'},
                    {value: 'Debug', label: '调试'},
                    {value: 'Rowlevel', label: '行级'},
                ],
                runResults: [
                    {value: 'SUCCESS', label: '成功'},
                    {value: 'FAILED', label: '失败'},
                ],
                data: null,
                dialogFormVisible: false,
                searchModel: {
                    nameLike: null,
                    types: null,
                    lastRunResult: null,
                    triggerStates: null,
                },
                searchParams: {
                    nameLike: null,
                    types: null,
                    lastRunResult: null,
                    triggerStates: null,
                },
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入任务名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    type: [
                        {required: true, message: '请选择任务类型', trigger: 'blur'},
                    ],
                    scheduleType: [
                        {required: true, message: '请选择定时方式', trigger: 'blur'},
                    ],
                    runTime: [
                        {required: true, message: '请选择运行时间', trigger: 'blur'},
                    ],
                    interval: [
                        {required: true, message: '请输入间隔时间', trigger: 'blur'},
                    ],
                    cron: [
                        {required: true, message: '请输入CRON表达式', trigger: 'blur'},
                        {validator: checkCron, trigger: 'blur'}
                    ],
                    logLevel: [
                        {required: true, message: '请选择日志级别', trigger: 'blur'},
                    ],
                    disabled: [
                        {required: true, message: '请选择是否停用', trigger: 'blur'},
                    ],
                },
                detailsDlg: {
                    model: null,
                    visible: false
                },
                logDialog: {
                    timer: null,
                    data: [],
                    from: 0,
                    visible: false
                }
            }
        },
        created() {
            this.init()
        },
        methods: {
            async init(){
                const response = await etlJobService.listAllEtlJobTypes()
                this.jobTypes = response.data.data
                this.fetchData(1)
            },
            async fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10, sort: 'id,desc'})
                const response = await etlJobService.listEtlJobs(params)
                this.data = response.data.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            search(){
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchData(1)
            },
            async onTypeChange(type){
                const response = await etlJobService.getEtlJobConfigTemplateByType(type)
                this.model.jobConfig = response.data.data
            },
            async addRow() {
                this.model = {
                    name: null,
                    type: null,
                    scheduleType: null,
                    runTime: null,
                    interval: null,
                    cron: null,
                    disabled: false,
                    jobConfig: null
                }
                if(this.$refs.form){
                    this.$refs.form.clearValidate()
                }
                this.dialogFormVisible = true
            },
            editRow(row) {
                etlJobService.getUpdateEtlJobForm(row.id).then(response => {
                    response.data.data.id = row.id
                    this.model = response.data.data
                    if(this.$refs.form){
                        this.$refs.form.clearValidate()
                    }
                    this.dialogFormVisible = true
                })
            },
            submitForm() {
                const validatePromises = []
                validatePromises.push(this.$refs.form.validate())
                Promise.all(validatePromises).then(() => {
                    if (this.model.id) {
                        etlJobService.updateEtlJob({id: this.model.id, data: this.model}).then(response => {
                            if(response.data.success){
                                this.dialogFormVisible = false
                                this.fetchData(this.data.number + 1)
                                this.$message({
                                    type: 'success',
                                    message: '修改成功!'
                                })
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: response.data.errorMsg
                                })
                            }
                        }).catch(error => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                            throw error
                        })
                    } else {
                        etlJobService.addEtlJob(this.model).then(response => {
                            if(response.data.success){
                                this.dialogFormVisible = false
                                this.fetchData(this.data.number + 1)
                                this.$message({
                                    type: 'success',
                                    message: '添加成功!'
                                })
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: response.data.errorMsg
                                })
                            }
                        }).catch(error => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                            throw error
                        })
                    }
                }).catch(() => {
                })
            },
            deleteRow(row) {
                this.$confirm('确定要删除该任务吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    etlJobService.deleteEtlJob(row.id).then(response => {
                        if(response.data.success){
                            if (this.data.content.length > 1) {
                                this.data.content.splice(this.data.content.indexOf(row), 1)
                            } else {
                                this.fetchData(this.data.number > 0 ? this.data.number : 1)
                            }
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                        }else{
                            this.$message({
                                type: 'error',
                                message: response.data.errorMsg
                            })
                        }
                    }).catch(error => {
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                        throw error
                    })
                }).catch(() => {
                });
            },
            disableRow(row) {
                this.$confirm('确定要停用该任务吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    etlJobService.disableEtlJob(row.id).then(response => {
                        if(response.data.success){
                            this.fetchData(this.data.number + 1)
                            this.$message({
                                type: 'success',
                                message: '停用成功!'
                            })
                        }else{
                            this.$message({
                                type: 'error',
                                message: response.data.errorMsg
                            })
                        }
                    }).catch(error => {
                        this.$message({
                            type: 'error',
                            message: '停用失败!'
                        })
                        throw error
                    })
                }).catch(() => {
                });
            },
            stopRow(row) {
                this.$confirm('确定要停止该任务吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    etlJobService.stopEtlJob(row.id).then(response => {
                        if(response.data.success){
                            this.fetchData(this.data.number + 1)
                            this.$message({
                                type: 'success',
                                message: '停止成功!'
                            })
                        }else{
                            this.$message({
                                type: 'error',
                                message: response.data.errorMsg
                            })
                        }
                    }).catch(error => {
                        this.$message({
                            type: 'error',
                            message: '停止失败!'
                        })
                        throw error
                    })
                }).catch(() => {
                });
            },
            enableRow(row) {
                this.$confirm('确定要启用该任务吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    etlJobService.enableEtlJob(row.id).then(response => {
                        if(response.data.success){
                            this.fetchData(this.data.number + 1)
                            this.$message({
                                type: 'success',
                                message: '启用成功!'
                            })
                        }else{
                            this.$message({
                                type: 'error',
                                message: response.data.errorMsg
                            })
                        }
                    }).catch(error => {
                        this.$message({
                            type: 'error',
                            message: '启用失败!'
                        })
                        throw error
                    })
                }).catch(() => {
                });
            },
            viewRow(row) {
                etlJobService.getEtlJobDetails(row.id).then(response => {
                    response.data.data.id = row.id
                    this.detailsDlg.model = response.data.data
                    this.detailsDlg.visible = true
                })
            },
            getJobScheduleDescription(row){
                switch(row.scheduleType){
                    case 'NONE':
                        return '未定时'
                    case 'ONCE':
                        return '于'+dateUtils.formatDateTime(row.runTime, 'YYYY-MM-DD HH:mm:ss')+'运行一次'
                    case 'INTERVAL':
                        return '每隔'+moment.duration(row.interval).humanize(false)+'运行一次'
                    case 'CRON':
                        return 'CRON定时'+row.cron
                }
            },
            getLogLevelDescription(level){
                return this.logLevels.find(item=>item.value===level).label
            },
            getTriggerStateDescription(state){
                if(!state){
                    return ''
                }
                return this.triggerStates.find(item=>item.value===state).label
            },
            getJobResultDescription(jobResult, runCost){
                if(!jobResult){
                    return ''
                }
                return '运行'+(jobResult === 'SUCCESS' ? '成功' : '失败')+'，耗时'+runCost+'毫秒'
            },
            showLogs(id){
                const data = []
                this.logDialog.data = data
                this.logDialog.from = 0
                const fetchLog = () => {
                    etlJobService.getEtlJobLogs(id, this.logDialog.from).then(response => {
                        if(this.logDialog.data !== data){
                            return
                        }
                        if(response.data.success){
                            data.push(...response.data.data.logString.split(/\r?\n/).filter(item=>item).map(item=>{return {log:item}}))
                            this.logDialog.from = response.data.data.lastLineNr
                            if(!response.data.data.finished){
                                this.logDialog.timer = setTimeout(fetchLog, 1000)
                            }
                        }else{
                            this.$message({
                                type: 'error',
                                message: response.data.errorMsg
                            })
                        }
                    }).catch(error => {
                        this.$message({
                            type: 'error',
                            message: '下载日志出错!'
                        })
                        throw error
                    })
                }
                fetchLog()
                this.logDialog.visible = true
            },
            onLogDialogClose(){
                if(this.logDialog.timer){
                    clearTimeout(this.logDialog.timer)
                    this.logDialog.timer = null
                }
            }
        }
    }
</script>
<style scoped>
</style>
